import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
  getJmsDetails,
  submitJmsData,
  approveJmsData 
} from 'services/redux/installation/jms/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

import SubmitJMS from './submitJMS';

const mapStateToProps = (state) => ({
  jmsDetailsState: state.jmsReducer?.jmsDetailsState || null,
  documentUrlDataPublic: state.fileUploadReducer?.documentUrlDataPublic || null,
});

const mapDispatchToProps = (dispatch) => ({
  getJmsDetails: bindActionCreators(getJmsDetails, dispatch),
  submitJmsData: bindActionCreators(submitJmsData, dispatch),
  approveJmsData: bindActionCreators(approveJmsData, dispatch),
  documentUploadUrlPublic: bindActionCreators(documentUploadUrlPublic, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitJMS);
